import { Combobox } from "@/components/ui/combobox";
import { toast } from "@/components/ui/use-toast";
import { api } from "@/lib/api";
import { useEffect, useState } from "react";

/** Which project a recorded meeting was about, changeable after the fact. */
export function MeetingProjectPicker({
  recordingId,
  projectId,
  projects,
  onSaved,
}: {
  recordingId: string;
  projectId: string | null;
  projects: Array<{ id: string; name: string }>;
  onSaved?: (projectId: string | null) => void;
}) {
  const [value, setValue] = useState(projectId ?? "");
  const [saving, setSaving] = useState(false);
  useEffect(() => setValue(projectId ?? ""), [projectId]);

  async function save(next: string) {
    const previous = value;
    setValue(next);
    setSaving(true);
    try {
      await api.patch(`/api/analysis/recordings/${encodeURIComponent(recordingId)}`, {
        projectId: next || null,
      });
      onSaved?.(next || null);
    } catch {
      setValue(previous);
      toast({ title: "Couldn't change the meeting's project", variant: "destructive" });
    } finally {
      setSaving(false);
    }
  }

  return (
    <Combobox
      size="sm"
      className="w-48"
      aria-label="Meeting project"
      data-testid="meeting-project"
      value={value}
      onChange={save}
      disabled={saving}
      options={[
        { value: "", label: "— no project —" },
        ...projects.map((p) => ({ value: p.id, label: p.name })),
      ]}
    />
  );
}
